import { useEffect, useMemo, useRef } from 'react';
import type { FieldProps } from './TextField';
import { useFormField } from '../../hooks/useFormField';
import { useFormContext } from '../../context/FormContext';
import { QuestionWrapper } from '../QuestionWrapper';

export function LocationField({ fieldSchema, group }: FieldProps) {
  const field = useFormField(fieldSchema, group);
  const { settings } = useFormContext();
  const elementId = useMemo(
    () => `location-${field.question.id}-${group.id}-${Math.floor(Math.random() * 100 + 1)}`,
    [field.question.id, group.id]
  );
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    const initGoogleMaps = () => {
      const googleMaps = (window as unknown as { google?: { maps?: { places?: { Autocomplete: new (el: HTMLInputElement, opts: unknown) => { addListener: (event: string, cb: () => void) => void; getPlace: () => { formatted_address?: string; address_components?: Array<{ types: string[]; long_name: string; short_name: string }>; geometry?: { location: { lat: () => number; lng: () => number } } } } }; LatLng: new (lat: number, lng: number) => unknown; LatLngBounds: new (sw: unknown, ne: unknown) => unknown } } }).google;

      if (!googleMaps?.maps?.places || !inputRef.current) {
        return;
      }

      const lookupBoundaries = [
        { lat: -47.3077, lng: 166.366 },
        { lat: -34.3508, lng: 178.6157 },
      ];

      const options = {
        bounds: new googleMaps.maps.LatLngBounds(
          new googleMaps.maps.LatLng(lookupBoundaries[0].lat, lookupBoundaries[0].lng),
          new googleMaps.maps.LatLng(lookupBoundaries[1].lat, lookupBoundaries[1].lng)
        ),
        strictBounds: false,
      };

      const autoComplete = new googleMaps.maps.places.Autocomplete(inputRef.current, options);

      autoComplete.addListener('place_changed', () => {
        const place = autoComplete.getPlace();

        if (place?.formatted_address) {
          field.setAnswer(place.formatted_address);
        }
      });
    };

    const timer = setTimeout(initGoogleMaps, 200);
    return () => clearTimeout(timer);
  }, [field]);

  return (
    <QuestionWrapper {...field} fieldSchema={fieldSchema}>
      <div className="answer-group">
        <div className="answer">
          <input
            ref={inputRef}
            type="text"
            className="text"
            value={String(field.answer ?? '')}
            onChange={(e) => field.setAnswer(e.target.value)}
            name={`address-lookup-${elementId}`}
            id={`address-lookup-${elementId}`}
          />
        </div>
      </div>

      <div className="answer-group" style={{ display: 'none' }}>
        <div className="answer">
          <input
            type="hidden"
            className="text"
            name={`address-lookup-${elementId}`}
            id={elementId}
          />
        </div>
      </div>
    </QuestionWrapper>
  );
}
